export enum Cy_Sablony {
  title = 'sablony-title',
  vytvoritSablonu = 'vytvorit-sablonu',

  kodSablony = 'kod-sablony',
  identifikator = 'identifikator',
  nazev = 'nazev',
  datumVytvoreni = 'datum-vytvoreni',
  kodOVM = 'kod-ovm',
  nazevOVM = 'nazev-ovm',
  status = 'status',
  datumSchvaleni = 'datum-schvaleni',
  platnostOd = 'platnost-od',
  platnostDo = 'platnost-do',
  typ = 'typ',

  search = 'sablony-search-button',
  clear = 'sablony-clear-filter-button',

  table = 'sablony-table',
  form = 'sablony-form',

  actionButton = 'sablony-action-button',

  /**
   * Detail
   */
  // Taby
  detailTab = 'detail-tab',
  stanoviskaTab = 'stanoviska-tab',
  parametrySchvalovaniTab = 'parametry-schvalovani-tab',

  // Detail
  downloadPdf = 'download-pdf',
  specifikaceTable = 'specifikace-table',
  dokumentaceTable = 'dokumentace-table',
  zastupTable = 'zastup-table',

  // Stanoviska
  stanoviskaZrusitButton = 'stanoviska-zrusit-button',
}

// readonly Cy_Sablony = Cy_Sablony;
// [attr.data-cy]="Cy_Sablony.title"
